import type { FaireProductEntity } from "../../entity_types/product";

export const p_9n2e4fnznc: FaireProductEntity = {
  token: "p_9n2e4fnznc",
  type: "product",
  name: "Good Moms Say Bad Words Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/21c3b0bc2acc04ba2f83ed63620df1322a2af508282bd512689bb2778674d72b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9bc051213466ac5ca629713d3a891e646238db755aaf83e7bbcbdb875908e332.jpeg",
    "https://cdn.faire.com/fastly/c2ef814ee302163e688f961e12a66960991227356fb9da0480e67a65647546b1.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/0cba11e407f2953c29600b04b91237d2384a5606fd201a7361439163b4e2f5a1.jpeg",
    "https://cdn.faire.com/fastly/fd496065616d3f4d3aa03fa9f7aac484968a1a50a256a24dd33314a74567fd98.jpeg"
  ],
  priceDollars: 6.75,
  description: "Socks for the matriarch in your life who is doing a really f**king good job. 💕\n\nPerfect Mother’s Day gift!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:54.538Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
